function openClubVinersPopup() {
  const popup = document.getElementById('club-viners-popup');
  if (popup) {
    popup.style.display = 'block';
    console.log('Popup opened, display:', popup.style.display);
    const selectionSection = document.getElementById('club-viners-selection-section');
    console.log('Selection section display:', selectionSection ? selectionSection.style.display : 'Section not found');
  } else {
    console.error('Popup element (#club-viners-popup) not found');
  }
}

function closeClubVinersPopup() {
  const form = document.getElementById('club-viners-selection-form');
  const selectedCount = form ? parseInt(form.getAttribute('data-selected-count')) : 0;
  const normalizedPlan = window.clubViners?.normalizedPlan || '';
  const isGrandSelectionPlan = [
    'grand selection - 2 botellas',
    'grand selection - 4 botellas'
  ].includes(normalizedPlan);
  const requiredProducts = isGrandSelectionPlan ? 2 : 3;

  if (selectedCount === requiredProducts) {
    const confirmClose = confirm('¿Estás seguro de que querés salir? No confirmaste tu selección de productos.');
    if (!confirmClose) return;
  }

  const popup = document.getElementById('club-viners-popup');
  if (popup) {
    popup.style.display = 'none';
    console.log('Popup closed');
  }
}

function initializeFichaTecnicaButtons() {
  console.log('Initializing Ficha Técnica buttons and close handlers');
  const section = document.getElementById('club-viners-selection-section');
  console.log('Section display:', section ? section.style.display : 'Section not found');

  const buttons = document.querySelectorAll('#club-viners-selection-section .club-viners-toggle-description');
  console.log('Found toggle buttons:', buttons.length);
  buttons.forEach(button => {
    button.removeEventListener('click', handleFichaTecnicaClick);
    button.addEventListener('click', handleFichaTecnicaClick);
    console.log('Toggle button initialized, productId:', button.getAttribute('data-product-id'));
  });

  const closeButtons = document.querySelectorAll('.club-viners-ficha-tecnica-close');
  console.log('Found close buttons:', closeButtons.length);
  closeButtons.forEach(button => {
    button.removeEventListener('click', handleFichaTecnicaClose);
    button.addEventListener('click', handleFichaTecnicaClose);
    console.log('Close button initialized');
  });

  const popups = document.querySelectorAll('.club-viners-ficha-tecnica-popup');
  console.log('Found popups:', popups.length);
  popups.forEach(popup => {
    popup.removeEventListener('click', handleFichaTecnicaPopupClick);
    popup.addEventListener('click', handleFichaTecnicaPopupClick);
    console.log('Popup initialized, id:', popup.id);
  });
}

function handleFichaTecnicaClick() {
  const productId = this.getAttribute('data-product-id');
  console.log('Ficha técnica clicked, productId:', productId);
  const fichaPopup = document.getElementById(`club-viners-ficha-tecnica-${productId}`);
  if (fichaPopup) {
    console.log('Popup found, opening:', fichaPopup);
    fichaPopup.style.display = 'block';
    fichaPopup.classList.add('active');
  } else {
    console.error('Popup not found for productId:', productId);
  }
}

function handleFichaTecnicaClose() {
  const fichaPopup = this.closest('.club-viners-ficha-tecnica-popup');
  if (fichaPopup) {
    console.log('Closing popup:', fichaPopup.id);
    fichaPopup.classList.remove('active');
    setTimeout(() => {
      fichaPopup.style.display = 'none';
    }, 300);
  } else {
    console.error('Popup not found for close button');
  }
}

function handleFichaTecnicaPopupClick(e) {
  if (e.target === this) {
    console.log('Clicked outside popup, closing:', this.id);
    this.classList.remove('active');
    setTimeout(() => {
      this.style.display = 'none';
    }, 300);
  }
}

function toggleSection(sectionId) {
  console.log('Toggling section:', sectionId);
  document.querySelectorAll('.club-viners-popup-section').forEach(section => {
    section.style.display = section.id === `club-viners-${sectionId}-section` ? 'block' : 'none';
  });
  document.querySelectorAll('.club-viners-nav-btn').forEach(btn => {
    btn.classList.toggle('active', btn.getAttribute('data-section') === sectionId);
  });
  const section = document.getElementById(`club-viners-${sectionId}-section`);
  if (section) {
    section.scrollIntoView({ behavior: 'smooth', block: 'start' });
    if (sectionId === 'selection') {
      setTimeout(() => {
        initializeFichaTecnicaButtons();
      }, 300);
    }
  } else {
    console.error('Section not found:', `club-viners-${sectionId}-section`);
  }
}

function initializePopup() {
  const popup = document.getElementById('club-viners-popup');
  if (!popup) {
    console.error('Popup (#club-viners-popup) not found during initialization');
    return;
  }

  const overlay = popup.querySelector('.club-viners-popup__overlay');
  const popupWindow = popup.querySelector('.club-viners-popup__window');
  const closeButton = popup.querySelector('.club-viners-popup__close');
  const form = document.getElementById('club-viners-selection-form');

  if (!overlay || !popupWindow || !closeButton) {
    console.error('Popup elements missing:', { overlay, popupWindow, closeButton });
    return;
  }

  overlay.addEventListener('click', closeClubVinersPopup);
  popupWindow.addEventListener('click', e => e.stopPropagation());
  closeButton.addEventListener('click', closeClubVinersPopup);

  document.querySelectorAll('.club-viners-nav-btn').forEach(btn => {
    btn.addEventListener('click', e => {
      e.preventDefault();
      const sectionId = btn.getAttribute('data-section');
      openClubVinersPopup();
      toggleSection(sectionId);
      console.log(`Nav button clicked, section: ${sectionId}, opening popup`);
    });
  });

  window.addEventListener('hashchange', () => {
    if (window.location.hash === '#club-viners') {
      openClubVinersPopup();
      toggleSection('selection');
      console.log('Hash changed to #club-viners, opening popup');
    }
  });

  if (window.location.hash === '#club-viners') {
    openClubVinersPopup();
    toggleSection('selection');
    console.log('Initial hash is #club-viners, opening popup');
  }

  const normalizedPlan = window.clubViners?.normalizedPlan || '';
  console.log('Normalized Plan:', normalizedPlan);
  if (!normalizedPlan) {
    console.warn('normalizedPlan is empty, defaulting to 3 products');
  }
  const isGrandSelectionPlan = [
    'grand selection - 2 botellas',
    'grand selection - 4 botellas'
  ].includes(normalizedPlan);
  const requiredProducts = isGrandSelectionPlan ? 2 : 3;
  console.log('Is Grand Selection:', isGrandSelectionPlan, 'Required Products:', requiredProducts);

  if (!form) {
    console.error('Form (club-viners-selection-form) not found');
    return;
  }

  const countDisplay = document.getElementById('club-viners-selected-count');
  const submitBtn = document.getElementById('club-viners-add-to-cart-btn');
  if (!submitBtn) {
    console.error('Submit button (club-viners-add-to-cart-btn) not found');
    return;
  }
  if (!countDisplay) {
    console.error('Count display (club-viners-selected-count) not found');
    return;
  }
  const loadingSpinner = document.getElementById('club-viners-loading-spinner');
  const buttonText = submitBtn.querySelector('.button-text');
  let selectedProducts = [];

  // Inicializar botones con estado limpio
  form.querySelectorAll('.club-viners-select-button').forEach(btn => {
    btn.disabled = false;
    btn.setAttribute('data-selected', 'false');
    btn.classList.remove('selected');
    btn.textContent = 'Seleccionar';
  });

  // Manejador para botones de selección
  form.addEventListener('click', e => {
    const button = e.target.closest('.club-viners-select-button');
    if (!button || button.disabled) {
      console.log('Click ignored: button not found or disabled');
      return;
    }

    const variantId = button.getAttribute('data-variant-id');
    if (!variantId) {
      console.error('Button missing data-variant-id:', button);
      return;
    }
    const isSelected = button.getAttribute('data-selected') === 'true';

    console.log('Button clicked, variantId:', variantId, 'isSelected:', isSelected);

    if (isSelected) {
      selectedProducts = selectedProducts.filter(id => id !== variantId);
      button.setAttribute('data-selected', 'false');
      button.classList.remove('selected');
      button.textContent = 'Seleccionar';
    } else if (selectedProducts.length < requiredProducts) {
      selectedProducts.push(variantId);
      button.setAttribute('data-selected', 'true');
      button.classList.add('selected');
      button.textContent = 'Seleccionado';
    } else {
      console.log('Cannot select more products, limit reached:', requiredProducts);
      return;
    }

    countDisplay.textContent = selectedProducts.length;
    form.setAttribute('data-selected-count', selectedProducts.length);
    submitBtn.disabled = selectedProducts.length !== requiredProducts;
    console.log('Selected products:', selectedProducts.length, 'Required:', requiredProducts, 'Submit button disabled:', submitBtn.disabled);

    form.querySelectorAll('.club-viners-select-button').forEach(btn => {
      const isBtnSelected = btn.getAttribute('data-selected') === 'true';
      btn.disabled = selectedProducts.length >= requiredProducts && !isBtnSelected;
      console.log('Button', btn.getAttribute('data-variant-id'), 'disabled:', btn.disabled, 'selected:', isBtnSelected);
    });
  });

  // Manejador explícito para el botón submit
  submitBtn.addEventListener('click', e => {
    console.log('Submit button clicked, disabled:', submitBtn.disabled);
    if (!submitBtn.disabled) {
      console.log('Dispatching form submit event');
      form.dispatchEvent(new Event('submit'));
    } else {
      console.log('Submit button is disabled, ignoring click');
    }
  });

  // Manejador para el evento submit
  form.addEventListener('submit', async e => {
    e.preventDefault();
    console.log('Form submitted, selectedProducts:', selectedProducts, 'Submit button disabled:', submitBtn.disabled);

    if (buttonText) buttonText.style.opacity = '0';
    if (loadingSpinner) loadingSpinner.style.display = 'inline-block';
    if (submitBtn) submitBtn.disabled = true;

    try {
      console.log('Clearing cart');
      const clearResponse = await fetch('/cart/clear.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' }
      });
      if (!clearResponse.ok) {
        console.error('Clear cart response:', clearResponse.status, clearResponse.statusText);
        throw new Error('Error al vaciar el carrito');
      }

      const isDoubleQuantityPlan = [
        'exploradores - 6 botellas',
        'clasicos - 6 botellas',
        'sorprendentes - 6 botellas',
        'notables - 6 botellas',
        'grand selection - 4 botellas'
      ].includes(normalizedPlan);
      console.log('Is double quantity plan:', isDoubleQuantityPlan);

      for (const variantId of selectedProducts) {
        const quantity = isDoubleQuantityPlan ? 2 : 1;
        console.log('Adding variant to cart:', variantId, 'Quantity:', quantity);
        const addResponse = await fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ id: variantId, quantity: quantity })
        });
        if (!addResponse.ok) {
          console.error('Add to cart response:', addResponse.status, addResponse.statusText);
          throw new Error(`Error al agregar variante ${variantId}`);
        }
      }

      console.log('Setting clubVinersCartLoaded in localStorage');
      localStorage.setItem('clubVinersCartLoaded', 'true');

      if (loadingSpinner) loadingSpinner.style.display = 'none';
      if (buttonText) buttonText.style.opacity = '1';
      const postSelectionPopup = document.getElementById('club-viners-post-selection-popup');
      if (postSelectionPopup) {
        console.log('Showing post-selection popup');
        postSelectionPopup.style.display = 'flex';
        postSelectionPopup.classList.add('active');
      } else {
        console.error('Post-selection popup not found');
      }
    } catch (error) {
      console.error('Submit error:', error);
      alert('Hubo un problema al procesar tu selección. Por favor, intentá de nuevo.');
      if (loadingSpinner) loadingSpinner.style.display = 'none';
      if (buttonText) buttonText.style.opacity = '1';
      if (submitBtn) submitBtn.disabled = selectedProducts.length !== requiredProducts;
    }
  });

  // Manejador global de clics para el popup post-selección
  document.addEventListener('click', e => {
    const targetId = e.target.id;
    const postSelectionPopup = document.getElementById('club-viners-post-selection-popup');
    const initialMessage = document.getElementById('club-viners-initial-message');
    const addProductsMessage = document.getElementById('club-viners-add-products-message');
    const confirmBoxMessage = document.getElementById('club-viners-confirm-box-message');

    // Evitar que el manejador global interfiera con el botón submit
    if (e.target.id === 'club-viners-add-to-cart-btn') {
      console.log('Ignoring global click handler for submit button');
      return;
    }

    if (targetId === 'club-viners-add-more-products-btn') {
      console.log('Add more products button clicked');
      document.getElementById('club-viners-initial-message').style.display = 'none';
      document.getElementById('club-viners-add-products-message').style.display = 'block';
    } else if (targetId === 'club-viners-go-to-shop-btn') {
      console.log('Go to shop button clicked');
      postSelectionPopup.style.display = 'none';
      submitBtn.disabled = selectedProducts.length !== requiredProducts;
      window.location.href = 'https://viners.com.ar';
    } else if (targetId === 'club-viners-confirm-box-btn') {
      console.log('Confirm box button clicked');
      document.getElementById('club-viners-initial-message').style.display = 'none';
      document.getElementById('club-viners-confirm-box-message').style.display = 'block';
    } else if (targetId === 'club-viners-continue-btn') {
      console.log('Continue button clicked');
      postSelectionPopup.style.display = 'none';
      submitBtn.disabled = selectedProducts.length !== requiredProducts;
      localStorage.removeItem('clubVinersCartLoaded');
      window.location.href = '/checkout';
    } else if (e.target.classList.contains('club-viners-post-selection-close')) {
      console.log('Post-selection close button clicked');
      if (addProductsMessage.style.display === 'block' || confirmBoxMessage.style.display === 'block') {
        addProductsMessage.style.display = 'none';
        confirmBoxMessage.style.display = 'none';
        initialMessage.style.display = 'block';
      } else {
        postSelectionPopup.style.display = 'none';
        submitBtn.disabled = selectedProducts.length !== requiredProducts;
      }
    }
  });

  setTimeout(() => {
    initializeFichaTecnicaButtons();
  }, 300);
}

document.addEventListener('DOMContentLoaded', initializePopup);